import formatMediaQuery from "./format-media-query";

export default formatMediaQuery;
